import './global.js';
import  wrapJewelryTab from './includes/silverGoldCalc.js';
import { v$ } from './includes/helpers'
import { closePopup, openPopup } from './includes/popupForm'

let parentGold = document.querySelector('#gold');

wrapJewelryTab({product: 'gold', parent:parentGold});

const promoCodeWrap = v$('.promo-code-wrap')[0];

if (promoCodeWrap) {
  let inputPromoType = document.querySelector('#type');
  inputPromoType.value = parentGold.getAttribute('id');
  const promoCodeLink = v$('.promo-code-text')[0],
    promoPopUp = v$('#promo')[0],
    promoPopUpClose =v$('#promo .popup-close')[0];
  promoCodeLink.addEventListener('click', (e) => {
    e.preventDefault();
    openPopup(promoPopUp);
  })

  promoPopUpClose.addEventListener('click', (e) => {
    e.preventDefault();
    closePopup(promoPopUp);
  })
}

